export default "<div class=\"lds-facebook\"><div></div><div></div><div></div></div>"